import * as React from 'react'
import { Stack as StyledStack } from '@chakra-ui/core'
import { StackProps as StyledStackProps } from '@chakra-ui/core/dist/Stack'

interface StackProps extends StyledStackProps {}

const Stack: React.FC<StackProps> = (props: StackProps): React.ReactElement => {
	return <StyledStack {...props} />
}

export { StackProps }

export default Stack
